import React, { Component, createRef, useState, memo } from 'react'
import PropTypes from 'prop-types'
import { v4 as uuid } from 'uuid'
import { Tooltip } from '@mui/material'
import { GridActionsCellItem } from '@mui/x-data-grid'

import { Logger, LoggerTypes } from '../../../utils'

/**
 * The ButtonIcon component can be used to display a rounded icon that open a popin onClick
 * Ex:
 *  - project = {name: '', id: 456, ...}
 *  - <ButtonIcon
 *      icon={<DeleteIcon/>}
 *      element={project}
 *      DialogClass={ProjectDialogDelete}
 *      tooltip={t('common.delete')}
 *    />
 * @returns {DialogClass}
 */
const ButtonIcon = ({
  DialogClass,
  icon,
  tooltip,
  element,
  params,
  extraDialogAttribute,
  style,
  disabled,
  isPopupVisible
}) => {
  const [openDialog, setOpenDialog] = useState(isPopupVisible)

  const ref = createRef()
  // TODO: Replace this by extraDialogAttribute:
  const { pid, sid, fid, vid, rid, mid, wid, lid, did } = params
  const uuidVal = uuid()
  const isTooltip = tooltip && typeof tooltip === 'string' && tooltip.length > 0

  const onClick = (e) => {
    e.stopPropagation()
    e.preventDefault()

    Logger.trace(LoggerTypes.CONTROLLER, 'ButtonIcon.onClick()', { params, e })

    setOpenDialog(!openDialog)
  }

  const dialog = (
    <DialogClass
      ref={ref}
      pid={pid} // project ID
      sid={sid} // scenario ID
      fid={fid} // flowGroup ID
      vid={vid} // variable ID
      rid={rid} // resource ID
      mid={mid} // parameter ID
      wid={wid} // weather ID
      lid={lid} // location ID
      did={did} // product ID
      project={element}
      scenario={element}
      flowGroup={element}
      variable={element}
      resource={element}
      product={element}
      weather={element}
      location={element}
      parameter={element}
      openDialog={openDialog}
      setOpenDialog={setOpenDialog}
      {...extraDialogAttribute}
    />
  )

  // Logger.trace(LoggerTypes.CONTAINER, 'ButtonIcon.render()', {
  //   pid, // Project ID
  //   sid, // Scenario ID
  //   fid, // FlowGroup ID
  //   vid, // Variable ID
  //   rid, // Resource ID
  //   mid, // Parameter ID
  //   wid, // Weather ID
  //   lid, // Location ID
  //   did, // Product ID
  //   params,
  //   element,
  //   extraDialogAttribute,
  //   isPopupVisible
  // })

  return (
    <React.Fragment key={`ButtonIcon-${uuidVal}`}>
      {isTooltip ? (
        <Tooltip ref={ref} title={tooltip}>
          <div>
            <GridActionsCellItem
              icon={icon}
              onClick={(e) => {
                if (!disabled) {
                  onClick(e)
                }
              }}
              disabled={disabled}
              style={style}
              label="Click for action"
            />
          </div>
        </Tooltip>
      ) : (
        <GridActionsCellItem
          icon={icon}
          onClick={(e) => {
            if (!disabled) {
              onClick(e)
            }
          }}
          disabled={disabled}
          style={style}
          label="Click for action"
        />
      )}
      {dialog}
    </React.Fragment>
  )
}

ButtonIcon.displayName = 'ButtonIcon'

ButtonIcon.propTypes = {
  DialogClass: PropTypes.any.isRequired,
  icon: PropTypes.any.isRequired,
  element: PropTypes.object,
  params: PropTypes.object,
  tooltip: PropTypes.string,
  style: PropTypes.object,
  disabled: PropTypes.bool,
  extraDialogAttribute: PropTypes.shape({
    title: PropTypes.string,
    dispatchAction: PropTypes.func
  }),
  isPopupVisible: PropTypes.bool
}

ButtonIcon.defaultProps = {
  DialogClass: Component,
  icon: null,
  element: {},
  params: {},
  tooltip: null,
  style: null,
  disabled: false,
  extraDialogAttribute: {},
  isPopupVisible: false
}

export default memo(ButtonIcon)
